import React from 'react';
import { SalesPage } from './components/SalesPage';
export function App() {
  return <SalesPage data-id="element-0" />;
}